"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const TailwindContext = (0, react_1.createContext)((_classNames) => ({}));
exports.default = TailwindContext;
